import React from "react";
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import moment from 'moment';

import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { getLanguage } from '@/utils/userStorage';

import { momentLocales } from '@/utils';
import './i18n';
// @ts-ignore
import 'moment/locale/ru.js';
import { enUS, ru, uk, type Locale } from 'date-fns/locale';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// Initialize plugin globally at app startup
dayjs.extend(customParseFormat);

const lang = getLanguage() || 'en';
// const momentLocales: { [key: string]: string } = {
//   en: 'en',
//   ru: 'ru',
//   ukr: 'uk',
// };
const dateFnsLocales: { [key: string]: { name: string; var: Locale } } = {
  en: {
    name: 'en-US',
    var: enUS,
  },
  ru: {
    name: 'ru',
    var: ru,
  },
  ukr: {
    name: 'uk',
    var: uk,
  },
};
moment.locale(momentLocales[lang]);
if (dateFnsLocales[lang]) {
  registerLocale(dateFnsLocales[lang].name, dateFnsLocales[lang].var);
  setDefaultLocale(dateFnsLocales[lang].name);
}

const root= createRoot(document.getElementById('root')!);

root.render(<App />);

function registerServiceWorker() {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    return navigator.serviceWorker.register('/sw.js');
  }
}

registerServiceWorker();
